import { Store } from '../../store';
import { browserTabAction } from '../../Actions/BrowserAction';

const browserTab = {
    isTabVisible: true,
    updateTabVisible: isTabVisible => {
        browserTab.isTabVisible = isTabVisible;
        Store.dispatch(browserTabAction(browserTab.isTabVisible));
    },
    init: () => {
        Store.dispatch(browserTabAction(browserTab.isTabVisible));
        document.addEventListener(
            'visibilitychange',
            function () {
                browserTab.updateTabVisible(!document.hidden);
            },
            false,
        );

        document.addEventListener(
            'focus',
            function () {
                browserTab.updateTabVisible(true);
            },
            false,
        );

        document.addEventListener('blur', function () {}, false);

        window.addEventListener(
            'focus',
            function () {
                browserTab.updateTabVisible(true);
            },
            false,
        );

        window.addEventListener('blur', function () {}, false);
    },
    isVisible: () => {
        return Store.getState()?.browserTabData?.isVisible;
    },
};

export default browserTab;
